function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0606 0.646447C14.4749 0.0606611 13.5251 0.0606611 12.9393 0.646447L5.88046 7.70532C5.36783 8.21796 5.00415 8.86028 4.82831 9.56361L4.02985 12.7575C3.94464 13.0982 4.04449 13.4587 4.29288 13.7071C4.54126 13.9555 4.90176 14.0553 5.24252 13.9701L8.43637 13.1717C9.13971 12.9958 9.78204 12.6322 10.2947 12.1195L17.3535 5.06066C17.9393 4.47487 17.9393 3.52513 17.3535 2.93934L15.0606 0.646447ZM13.8232 2.59099C13.9208 2.49336 14.0791 2.49336 14.1768 2.59099L15.409 3.82322C15.5066 3.92086 15.5066 4.07915 15.409 4.17678L8.88046 10.7053C8.62415 10.9616 8.30298 11.1435 7.95132 11.2314L6.77859 11.5246C6.59549 11.5703 6.42966 11.4045 6.4754 11.2214L6.76859 10.0487C6.85651 9.69701 7.03836 9.37586 7.29468 9.11954L13.8232 2.59099Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 5C2 4.44772 2.44772 4 3 4H6C6.55228 4 7 3.55229 7 3C7 2.44772 6.55228 2 6 2H3C1.34314 2 0 3.34315 0 5V15C0 16.6569 1.34314 18 3 18H13C14.6569 18 16 16.6569 16 15V12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V15C14 15.5523 13.5523 16 13 16H3C2.44772 16 2 15.5523 2 15V5Z"
});

var SvgPencil = function SvgPencil(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#18B6FF"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/pencil.38ab2d84.svg";
export { SvgPencil as ReactComponent };